import { app } from '../../../../../app';
import { Controller } from './remove-account.controller';

app.component('companyUserDirectoriesManageAccountRemove', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./remove-account.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/remove/remove-account.component.js